// React Imports
import React, { useState } from "react";

// Internationalization Import
import i18n from "i18next";

// Internal Imports
import { fetchWrapper } from "../../helpers/fetchwrapper";
import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
} from "@fluentui/react-components";

// Props
interface IExecuteDialogProps {
  isDialogOpen: boolean;
  title: string;
  subText: string;
  primaryButtonIconName?: any;
  primaryButtonText: string;
  executeUrl?: string;
  onDismiss(): void;
  onExecute(data?: any): void;
  onError(error?: any): void;
}

// Function
function ExecuteDialog(props: IExecuteDialogProps) {
  const [isIdle, setIsIdle] = useState<boolean>(true);
  const executeUrl = () => {
    setIsIdle(false);

    fetchWrapper
      .get(`${props.executeUrl}`)
      .then((data: any) => {
        props.onExecute(data);
      })
      .catch(() => {
        props.onError();
      })
      .finally(() => {
        setIsIdle(true);
      });
  };

  return (
    <Dialog open={props.isDialogOpen}>
      <DialogSurface>
        <DialogBody>
          <DialogTitle>{props.title}</DialogTitle>
          <DialogContent>{props.subText}</DialogContent>
          <DialogActions>
            <Button
              disabled={!isIdle}
              appearance="secondary"
              onClick={() => props.onDismiss()}
            >
              {i18n.t<string>("cancel")}
            </Button>

            <Button
              disabled={!isIdle}
              appearance="primary"
              onClick={() => {
                if (props.executeUrl) {
                  executeUrl();
                } else {
                  props.onExecute();
                }
              }}
            >
              {props.primaryButtonText}
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
}

// Export Function
export default ExecuteDialog;
